module.exports = __webpack_public_path__ + "static/media/iv_order_cancelled.ad30ed5d.svg";